import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type PerSiteLocalPrefsState = {
  perSiteLocalPrefs: {
    [siteId: number]:
      | {
          showAllIntervalMetrics?: boolean;
        }
      | undefined;
  };
};

type PerSiteLocalPrefsActions = {
  toggleShowIntervalMetrics: (siteId: number) => void;
};

const initialState: PerSiteLocalPrefsState = {
  perSiteLocalPrefs: {},
};

export const createPerSiteLocalPrefsSlice: WaterlyAppStateCreator<
  PerSiteLocalPrefsActions,
  PerSiteLocalPrefsState
> = (set) => ({
  ...initialState,

  toggleShowIntervalMetrics: (siteId: number) =>
    set((s) => {
      const existingSitePrefs = s.perSiteLocalPrefs[siteId] ?? {
        showAllIntervalMetrics: true,
      };

      s.perSiteLocalPrefs[siteId] = {
        ...existingSitePrefs,
        showAllIntervalMetrics: !existingSitePrefs.showAllIntervalMetrics,
      };
    }),
});
